import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import Landing from "./pages/Landing";
import CheckoutSuccess from "./pages/CheckoutSuccess";
import Access from "./pages/Access";
import Verify from "./pages/Verify";
import Library from "./pages/Library";
import ScenarioDetail from "./pages/ScenarioDetail";
import AdminLogin from "./pages/AdminLogin";
import Admin from "./pages/Admin";
import Unsubscribe from "./pages/Unsubscribe";
import { AuthProvider } from "./lib/auth";

/**
 * GAPageViews — pushes a Google Analytics 4 page_view event on every
 * client-side route change. GA's automatic page tracking only fires on full
 * page loads, so SPA navigation between scenarios wouldn't get counted
 * without this hook.
 */
function GAPageViews() {
  const location = useLocation();
  useEffect(() => {
    if (typeof window.gtag !== "function") return;
    window.gtag("event", "page_view", {
      page_path: location.pathname + location.search,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [location]);
  return null;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <GAPageViews />
        <Toaster position="top-center" richColors closeButton />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/checkout/success" element={<CheckoutSuccess />} />
          <Route path="/access" element={<Access />} />
          <Route path="/verify" element={<Verify />} />
          <Route path="/library" element={<Library />} />
          <Route path="/library/:slug" element={<ScenarioDetail />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/unsubscribe" element={<Unsubscribe />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
